import React from "react"
import { Link } from "react-router-dom";
import { servicesData } from "../ServiceCard/service_data";
import webLogo from "../../assets/icons/webLogo.svg";
import facebook from "../../assets/icons/social icons/facebook.svg";
import linkedin from "../../assets/icons/social icons/tiktok.svg";
import insta from "../../assets/icons/social icons/insta.svg";
import footer_background from "../../assets/pictures/footer_background.jpg";
import callIcon from "../../assets/icons/callIcon.svg";
import emailIcon from "../../assets/icons/emailIcon.svg";
import LocationIcon from "../../assets/icons/LocationIcon.svg";

import call_icon from "../../assets/icons/footer icons/1.svg";
import email_icon from "../../assets/icons/footer icons/2.svg";
import location_icon from "../../assets/icons/footer icons/3.svg";
import whatsapp_icon from "../../assets/icons/footer icons/4.svg";
import "./Footer.css";

// import bullet from "../../assets/icons/bullet.svg";
import bullet from "../../assets/icons/bullet_point.svg";

// "/src/assets/icons/bullet.svg"

function Footer(){
    return(
        <>
        <footer className="footer" style={{ backgroundImage: `url(${footer_background})` }}>
            <div className="footer_main_conatain">
            <div className="footer_left">
                <div>
                <img src={webLogo} className="footer_weblogo" alt="company_logo"/>
                <p>AIN AL SADA is a leading Dubai-based home maintenance company, specialising in delivering fast, reliable, and professional services for villas, apartments, and businesses across the UAE.</p>
                </div>

                <div className="social_contain">
                    <h3>social</h3>
                    <ul>
                        <li>
  <a
    href="https://www.facebook.com/profile.php?id=61589083154407"
    target="_blank"
    rel="noopener noreferrer"
  >
    <div className="social_icon_contain">
      <img src={facebook} alt="facebook_icon" />
    </div>
  </a>
</li>

<li>
  <a
    href="https://instagram.com/yourpage"
    target="_blank"
    rel="noopener noreferrer"
  >
    <div className="social_icon_contain">
      <img src={insta} alt="instagram_icon" />
    </div>
  </a>
</li>

<li>
  <a
    href="https://www.tiktok.com/@ain.al.sada?_r=1&_t=ZS-96AZOj3jUj2"
    target="_blank"
    rel="noopener noreferrer"
  >
    <div className="social_icon_contain">
      <img src={linkedin} alt="linkedin_icon" />
    </div>
  </a>
</li>
                    </ul>

                </div>
            </div>
            <div className="footer_mid">
                <h1 className="footer_mid_heading">What we do</h1>
   <ul className="footer_list">
  {servicesData.map((service) => (
    <li key={service.id}>
      <img src={bullet} alt="bullet" />
      <Link to={`/service/${service.id}`} style={{ textDecoration: 'none', color: 'inherit', cursor: 'pointer' }}>
        {service.title}
      </Link>
    </li>
  ))}
</ul>

            </div>
            <div className="footer_right">
  <h1 className="footer_mid_heading">Reach Us</h1>

  <div className="footer_address">
    <img src={location_icon} className="footer_icon" />
    Al Quoz, Dubai, United Arab Emirates.
  </div>

  <div className="footer_phone">
  <div className="footer_contact num1"><img src={call_icon} className="footer_icon"/>
                      <a className="footer_num" href="tel:+971521743345">
                          +971 52 174 3345
                      </a></div>
  <div className="footer_contact"><img src={whatsapp_icon} className="footer_icon"/>
                      <a className="footer_num"  href="https://wa.me/971521743345"
  target="_blank"
  rel="noopener noreferrer">
                          +971 52 174 3345
                      </a></div>
  </div>

 <div className="footer_email">
  <img src={email_icon} className="footer_icon" alt="email" />

  <a
    href="mailto:info@ainalsadapropertycare.ae"
    className="footer_num footer_email_link"
  >
    info@ainalsadapropertycare.ae
  </a>
</div>
</div></div>
            
            <div className="footer_bottom">© 2026 AIN AL SADA. All rights reserved. | Trusted Home Maintenance Services in Dubai</div>
        </footer>
        </>
    )
}

export default Footer